import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ThreatmetrixService } from '@freelancer/threatmetrix';

@Component({
  standalone: false,
  selector: 'webapp-compat-threatmetrix',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompatThreatmetrixComponent implements OnInit {
  private threatMetrixService = inject(ThreatmetrixService);

  ngOnInit(): void {
    // Load the external script on page load
    this.threatMetrixService.getSession();
    window.webappCompatThreatmetrix = {
      getSession: this.threatMetrixService.getSession,
    };
  }
}
